export default {
  MY_ATTENDANCE: {
    TITLE: `My Attendance`,
    SUMMARY: ``
  },
  CREATE_ATTENDANCE_REQUEST: `Create an attendance request`,
  ON: `on`,
  CANCEL_MODAL: {
    TITLE: `Are you sure?`,
    SUMMARY: `Cancelling a request cannot be undone.`,
    PRIMARY_ACTION: `Cancel request`
  },
  NO_ATTENDANCE: `No attendance to display.`,
  TOTAL_ABSENCES_IN_BANK: `You requested {{ totalAbsences }} absence(s) in the last {{ period }} days`,
  ABSENCE_OVER_THRESHOLD: `Absence over the threshold`,
  THIS_ABSENCE_WILL_BE_OVER_THRESHOLD: `This absence will be over the allowed threshold by your company`
}
